<template>
<div>
    <MonitorPage :stop="stop" :kiosk="kiosk" class="monitor" />
</div>
</template>

<script>
import MonitorPage from '../components/MonitorPage.vue'

export default {
  name: 'Departures',
  components: {
    MonitorPage
  },
  data: () => {
    return {
      stop: {
        id: 0,
        name: ''
      },
      kiosk: false
    }
  },
  created: function () {
    this.stop.id = this.$route.query.id
    this.kiosk = Boolean(this.$route.query.kiosk)
  }
}
</script>

<style scoped>
body {
    overflow: hidden;
}
</style>
